<template>
  <div>
    <h1>Products</h1>
    <div class="construction">
      <b-row align-h="center">

          <h4><span><img src="../assets/icons/crane.png" alt="Crane"></span><em>Coming Soon...</em></h4>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Products'
}
</script>

<style scoped>
img {
  filter: invert(100%);
  width: 40px;
  margin-right: 2rem;
}
h1, h4{
  color: white;
}

.construction {
  border: 0.5px solid white;
  padding: 3rem;
}

</style>